import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    FormText,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { apiService } from '../../constants/ApiService';
import { Value } from 'sass';
import ReactPaginate from 'react-paginate';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import NoDataFound from '../../constants/NoDataFound';


const Item = () => {


    //----------- REDUCE TOOLKIT -------
    const vendorState = useSelector((state) => state.vendorState);
    const branchState = useSelector((state) => state.branchState);
        const [errorMessage, setErrorMessage] = useState({});
    
        const { user } = useSelector((state) => state.authState);
    
        const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
            useVendorBranch(user);
    
        const [selectionData, setSelectionData] = useState({
            vendor_id: "",
            branch_id: "",
        });


    const navigate = useNavigate();
    const [itemTable, setItemTable] = useState([]);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination

    const onHandleAddItem = () => {
        navigate("/additem")
    }

    const onHandleEditItem = (id) => {
        let findArrayData = itemTable.find(e => e.id === id);
        navigate('/additem', { state: { itemId: findArrayData.id } });
    };

    const onHandleSearchKeyItem = (e) => {
        const value = e.target.value; // Assuming you're trying to get the value from an input field
        getItemData(1, 10, value)
    }
    const getItemData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };


            // Build query string
            let queryParams = `/api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}`;
            
            const vendorId = selectionData.vendor_id;
            const branchId = selectionData.branch_id;
            queryParams += `&venderMasterId=${vendorId}`;
            queryParams += `&branchMasterId=${branchId}`;
            
            const response = await apiService.get(queryParams, config);
            // const response = await apiService.get(`/api/ItemMaster/allitem?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setItemTable(response.itemMasterDetailData)
                setTotalPage(response.totalPages)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    const handlePageClick = (data) => {
        getItemData(data.selected + 1)
    };

    const onHandleDeleteItem = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/ItemMaster/delete?itemId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getItemData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };


    // =======================  VENDER & BRANCH =================

    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedBranchId, setSelectedBranchId] = useState("");

    // Handle vendor selection change
    const selectVendorFilter = (e) => {

        let value = e.target.value
        if (!value) {
            setSelectedVendorId(value);
            setSelectedBranchId("");
        } else {
            setSelectedVendorId(value);
            setSelectedBranchId("");
            getItemData(1, 10, "", value)
        }
    };


    // Handle branch selection change
    const selectbranchFilter = (e) => {
        setSelectedBranchId(e.target.value);
    };

  
          useEffect(() => {
              const canLoad = conditionalDataLoad({
                  hasMultiBranch,
                  hasSingleBranch,
                  isSuperAdmin,
                  isAdmin,
                  vendorId: selectionData.vendor_id,
                  branchId: selectionData.branch_id,
              });
      
              if (canLoad) {
                  getItemData(1, 100, "");
              }
              // eslint-disable-next-line react-hooks/exhaustive-deps
          }, [selectionData]);

    // useEffect(() => {

    //     if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
    //         getItemData(1, 10, "")
    //     } else if (user.user_profile == "superadmin") {
    //         getItemData(1, 10, "")
    //     }

    //     if (vendorState.vendors.length == 1) {
    //         setSelectedVendorId(vendorState.vendors[0].id);
    //     }

    //     if (branchState.branches.length == 1) {
    //         setSelectedBranchId(branchState.branches[0].id);
    //     }
    // }, [selectedVendorId, selectedBranchId])

    return (
        <>
        <div className="text-right mb-2">
                                        <Button color="success" onClick={onHandleAddItem} >
                                            <i className="bi bi-plus-circle mr-2"></i>
                                            New
                                        </Button>
                                    </div>
                            <VendorBranchSelector
                                user={user}
                                selectionData={selectionData}
                                setSelectionData={setSelectionData}
                                errorMessage={errorMessage}
                                accessButton={true}
                            />

                <Card className='bg-white pd-10 card-box mb-30'>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">

                        <Col>

                            <Row className="align-items-center  g-0 mb-2">
                                <Col xs={12} className="d-flex justify-content-between align-items-center">
                                    {/* Title aligned left */}
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-box mr-2"></i>
                                        Item Master
                                    </div>                                   

                                </Col>
                            </Row>


                            <Row style={{ display: "flex", justifyContent: "start" }}>
                                <Col xl={12} md={6} className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">
                                    <Input
                                        
                                        id="search"
                                        name="search"
                                        placeholder="Search..."
                                        type="text"
                                        // style={{ minWidth: '250px' }}
                                        onChange={(e) => onHandleSearchKeyItem(e)}
                                    />
                                </Col>
                            </Row>

                        </Col>

                    </CardTitle>

                    <CardBody className="">
                        <div className="table-responsive">
                            <Table striped>
                                <thead>
                                    <tr>
                                         <th>S. no.</th>
                                        {(user.user_profile == "superadmin" || branchState.length) && <th>Branch/Vendor Name</th>}

                                        <th>Item Name</th>
                                        <th>Item Code</th>
                                        <th>Item Group</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemTable.map((item, index) => (
                                        <tr key={index}>
                                            {/* <th scope="row">{index + 1}</th> */}

                                            <th scope='row' >
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "start", flexDirection: "column" }}>
                                                    <span className='ms-2'>{index + 1}</span>

                                                    <Button
                                                        color="warning"
                                                        className="me-0 ms-2"
                                                        size="sm"
                                                        onClick={() => onHandleEditItem(item.id)}
                                                    >

                                                        <p style={{ fontSize: 12, padding: 0, margin: 0, fontWeight: "bold" }}><i className="bi bi-pencil mr-1"></i>Edit</p>
                                                    </Button>

                                                </div>
                                            </th>
                                            {(user.user_profile == "superadmin" || branchState.length) &&
                                                <td> {item.branch_name} ***** <br></br>{item.vender_name}</td>}
                                            <td>{item.item_name}</td>
                                            <td>{item.item_short_name}</td>
                                            <td>{item?.group}</td>
                                            
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                    <CardBody>
                        {/* <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        /> */}






                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />

                    </CardBody>
                </Card>
        </>
    )
}

export default Item













